import { defineMessages } from "react-intl";

const messages = defineMessages({
  wsbBusiness1: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature1",
    defaultMessage: "Create a website easily with AI website builder",
  },
  wsbBusiness2: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature2",
    defaultMessage: "Show up in more Google searches with built-in SEO tools",
  },
  wsbBusiness3: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature3",
    defaultMessage: "Save time with AI writing assistant",
  },
  wsbBusiness4: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature4",
    defaultMessage: "Add unlimited webpages to your site",
  },
  wsbBusiness5: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature5",
    defaultMessage: "Expand your site with 15+ integrations",
  },
  wsbBusiness6: {
    id: "orderflow.upsellCards.websiteBuilder.business.feature6",
    defaultMessage: "Look professional with business email included",
  },
  ecommerce1: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature1",
    defaultMessage: "Create a website easily with AI website builder ",
  },
  ecommerce2: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature2",
    defaultMessage: "Show up in more Google searches with built-in SEO tools",
  },
  ecommerce3: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature3",
    defaultMessage: "Hassle-free shipping with Shipmondo integration",
  },
  ecommerce4: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature4",
    defaultMessage: "Improve your revenue with 10+ payment methods",
  },
  ecommerce5: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature5",
    defaultMessage: "Add unlimited webpages and products to your site",
  },
  ecommerce6: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.feature6",
    defaultMessage: "Look professional with business email included",
  },
  mini1: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature1",
    defaultMessage: "Simplified website creation with AI builder",
  },
  mini2: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature2",
    defaultMessage: "Easy-to-use drag and drop design tool",
  },
  mini3: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature3",
    defaultMessage: "10 pages",
  },
  mini4: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature4",
    defaultMessage: "Integrated AI writing assistant",
  },
  mini5: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature5",
    defaultMessage: "Professional email included",
  },
  mini6: {
    id: "orderflow.upsellCards.websiteBuilder.mini.feature6",
    defaultMessage: "Mobile app",
  },
  pro1: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature1",
    defaultMessage: "Simplified website creation with AI builder",
  },
  pro2: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature2",
    defaultMessage: "Easy-to-use drag and drop design tool",
  },
  pro3: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature3",
    defaultMessage: "Unlimited pages",
  },
  pro4: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature4",
    defaultMessage: "Integrated AI writing assistant",
  },
  pro5: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature5",
    defaultMessage: "Professional email included",
  },
  pro6: {
    id: "orderflow.upsellCards.websiteBuilder.pro.feature6",
    defaultMessage: "Mobile app",
  },
  wsbBusinessDescription: {
    id: "orderflow.upsellCards.websiteBuilder.business.description",
    defaultMessage:
      "Promote your business online and expand your brand with professional growth and marketing tools.",
  },
  wsbBusinessHeading: {
    id: "orderflow.upsellCards.websiteBuilder.business.heading",
    defaultMessage:
      "Build a business-ready website quickly with AI and win online",
  },
  ecommerceDescription: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.description",
    defaultMessage:
      "Boost your revenue with AI-powered online store features and built-in marketing and growth tools.",
  },
  ecommerceHeading: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.heading",
    defaultMessage:
      "Start selling online immediately with ecommerce tools that help you grow your business. ",
  },
  miniDescription: {
    id: "orderflow.upsellCards.websiteBuilder.mini.description",
    defaultMessage:
      "Get a complete solution that includes hosting and email. Generate a website with AI and refine it with drag and drop.",
  },
  miniHeading: {
    id: "orderflow.upsellCards.websiteBuilder.mini.heading",
    defaultMessage: "Build and launch your website with AI, no coding needed.",
  },
  proDescription: {
    id: "orderflow.upsellCards.websiteBuilder.pro.description",
    defaultMessage:
      "Get a complete solution that includes hosting and email. Generate a website with AI and refine it with drag and drop.",
  },
  proHeading: {
    id: "orderflow.upsellCards.websiteBuilder.pro.heading",
    defaultMessage: "Build and launch your website with AI, no coding needed.",
  },
});

const getWSBPlansFeatures = (wsbPlan) => {
  const features = {
    WSB_MINI: [
      { ...messages.mini1 },
      { ...messages.mini2 },
      { ...messages.mini3 },
      { ...messages.mini4 },
      { ...messages.mini5 },
      { ...messages.mini6 },
    ],
    WSB_BUSINESS: [
      { ...messages.wsbBusiness1 },
      { ...messages.wsbBusiness2 },
      { ...messages.wsbBusiness3 },
      { ...messages.wsbBusiness4 },
      { ...messages.wsbBusiness5 },
      { ...messages.wsbBusiness6 },
    ],
    WSB_PRO: [
      { ...messages.pro1 },
      { ...messages.pro2 },
      { ...messages.pro3 },
      { ...messages.pro4 },
      { ...messages.pro5 },
      { ...messages.pro6 },
    ],
    WSB_ECOMMERCE: [
      { ...messages.ecommerce1 },
      { ...messages.ecommerce2 },
      { ...messages.ecommerce3 },
      { ...messages.ecommerce4 },
      { ...messages.ecommerce5 },
      { ...messages.ecommerce6 },
    ],
  };

  return features[wsbPlan];
};

export default getWSBPlansFeatures;
